import { Dispatch } from "react-redux";
import { AuthActionCreators, IApplicationState } from "../";
import { IBaseResponse, ICenterBase } from "../../models";

export interface IAvailableRecipientPairedDonor {
    id: number,
    alias: string,
    centerId: number,
    centerAlias: string
}

export interface IAvailableRecipient {
    id: number,
    alias: string,
    centerId: number,
    pairedDonors: IAvailableRecipientPairedDonor[]
}

export interface IAvailableRecipientListResponse {
    success: boolean,
    results: {
        recipientList: IAvailableRecipient[],
        centerList: ICenterBase[]
    }
}

export const ActionCreatorsSwapManagement = {
    getAvailableRecipients: () => (dispatch: Dispatch<IApplicationState>): Promise<IAvailableRecipientListResponse> => {
        let options = {
            url: `${__API__}/admin/cluster/available-recipients`,
        };

        return dispatch(AuthActionCreators.apiGetWithType<IAvailableRecipientListResponse>(options)).then(response => response.data);
    },

    bridgeDonor: (donorId: number, chainId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/donor/${donorId}/bridge/${chainId}`
        }

        return await dispatch(AuthActionCreators.apiGet(options));
    },

    unBridgeDonor: (donorId: number, chainId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/donor/${donorId}/unbridge/${chainId}`
        }

        return await dispatch(AuthActionCreators.apiGet(options));
    },

    convertToVoucher: (donorId: number, originalChainId: number, newChainId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/donor/${donorId}/convert-to-voucher/${originalChainId}?newChainId=${newChainId}`
        }

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    
    cancelCluster: (clusterId: number, firstDonorId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/cluster/${clusterId}/cancel?firstDonorId=${firstDonorId}`
        }

        return await dispatch(AuthActionCreators.apiGet(options));
    },

    removeRecipientFromCluster: (clusterId: number, recipientId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/admin/cluster/remove-recipient?clusterId=${clusterId}&recipientId=${recipientId}`
        }

        return await dispatch(AuthActionCreators.apiPost(options));
    },

    removePairFromCluster: (clusterId: number, positionNumber: number, recipientId: number, bridgeDonorId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/admin/cluster/remove-pair`,
            data: {
                clusterId,
                positionNumber,
                recipientId,
                bridgeDonorId
            }
        }

        return await dispatch(AuthActionCreators.apiPost(options));
    },

    replaceRecipientInCluster: (clusterId: number, recipientId: number, replacementRecipientId: number, bridgeDonorId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/admin/cluster/replace-recipient`,
            data: {
                clusterId,
                recipientId,
                replacementRecipientId,
                bridgeDonorId
            }
        }

        return await dispatch(AuthActionCreators.apiPost(options));
    },

    replacePairInCluster : (clusterId: number, currentBridgeDonorId: number, replacementRecipientId: number, bridgeDonorId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/admin/cluster/replace-pair`,
            data: {
                clusterId,
                currentBridgeDonorId,
                replacementRecipientId,
                bridgeDonorId
            }
        }

        return await dispatch(AuthActionCreators.apiPost(options));
    },

    addRecipientToCluster : (clusterId: number, positionNumber: number, recipientId: number, bridgeDonorId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API__}/admin/cluster/add-recipient`,
            data: {
                clusterId,
                positionNumber,
                recipientId,
                bridgeDonorId
            }
        }

        return await dispatch(AuthActionCreators.apiPost(options));
    },
}